/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiScreeningClearanceRuleTestResult
 */
export interface ApiScreeningClearanceRuleTestResult {
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningClearanceRuleTestResult
     */
    ruleResults: string;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningClearanceRuleTestResult
     */
    viewedObject: string;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningClearanceRuleTestResult
     */
    recordId?: string;
}

/**
 * Check if a given object implements the ApiScreeningClearanceRuleTestResult interface.
 */
export function instanceOfApiScreeningClearanceRuleTestResult(value: object): value is ApiScreeningClearanceRuleTestResult {
    if (!('ruleResults' in value) || value['ruleResults'] === undefined) return false;
    if (!('viewedObject' in value) || value['viewedObject'] === undefined) return false;
    return true;
}

export function ApiScreeningClearanceRuleTestResultFromJSON(json: any): ApiScreeningClearanceRuleTestResult {
    return ApiScreeningClearanceRuleTestResultFromJSONTyped(json, false);
}

export function ApiScreeningClearanceRuleTestResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningClearanceRuleTestResult {
    if (json == null) {
        return json;
    }
    return {
        
        'ruleResults': json['ruleResults'],
        'viewedObject': json['viewedObject'],
        'recordId': json['recordId'] == null ? undefined : json['recordId'],
    };
}

export function ApiScreeningClearanceRuleTestResultToJSON(json: any): ApiScreeningClearanceRuleTestResult {
    return ApiScreeningClearanceRuleTestResultToJSONTyped(json, false);
}

export function ApiScreeningClearanceRuleTestResultToJSONTyped(value?: ApiScreeningClearanceRuleTestResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ruleResults': value['ruleResults'],
        'viewedObject': value['viewedObject'],
        'recordId': value['recordId'],
    };
}

